/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {Injector, NgModule} from '@angular/core';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  NbActionsModule,
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule, NbIconModule, NbLayoutModule,
  NbMenuModule, NbSearchModule,
  NbSidebarModule, NbThemeModule,
  NbToastrModule, NbUserModule,
  NbWindowModule,
} from '@nebular/theme';
import { DashboardlayoutComponent } from './layout/dashboardlayout/dashboardlayout.component';
import { DashboardlayoutHeaderComponent } from './layout/dashboardlayout-header/dashboardlayout-header.component';
import { DashboardlayoutFooterComponent } from './layout/dashboardlayout-footer/dashboardlayout-footer.component';
import {StoreModule} from "@ngrx/store";
import {loanApplicationReducer} from "@app/store/loanapplication.reducer";
import {EffectsModule} from "@ngrx/effects";
import {LoanApplicationEffects} from "@store/loanapplication.effects";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {SharedModule} from "@modules/shared/shared.module";
import {NbSecurityModule} from "@nebular/security";
import {
  LoanApplicationBorrowerLayoutComponent
} from "@layout/loan-application-borrower-layout/loan-application-borrower-layout.component";
import {TokenInterceptor} from "@app/@core/interceptors/token.interceptor";
import {AuthGuard} from "@app/@core/interceptors/auth.guard";
import {ProfileComponent} from "@layout/profile/profile.component";
import {QuickquoteLayoutComponent} from "@layout/quickquote-layout/quickquote-layout.component";
import {HeaderComponent} from "@layout/header/header.component";
import {FooterComponent} from "@layout/footer/footer.component";

@NgModule({
  declarations: [
    AppComponent,
    DashboardlayoutComponent,
    DashboardlayoutHeaderComponent,
    DashboardlayoutFooterComponent, LoanApplicationBorrowerLayoutComponent,
    ProfileComponent ,HeaderComponent,FooterComponent ,QuickquoteLayoutComponent],


  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    NbLayoutModule,
    NbIconModule,
    EffectsModule.forRoot([LoanApplicationEffects]),
    StoreModule.forRoot(
      {
        loanApplication: loanApplicationReducer
      },
      {}
    ),
    FormsModule,
    ReactiveFormsModule,
    NbActionsModule,
    NbSearchModule,
    NbUserModule,
    SharedModule,
    NbSecurityModule,
    NbThemeModule,






  ],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: TokenInterceptor,
    multi: true,

  },AuthGuard],


  bootstrap: [AppComponent],
  exports: [
      ]
})
export class AppModule {
  constructor(private injector: Injector) {
    AppInjector = this.injector;
  }
}
export let AppInjector: Injector;


